import { customInspectionTypeSettings } from '../../../common/src/domain/customInspectionTypes/customInspectionTypeSettings';
import { InspectionStandardTypes } from './enums/InspectionStandardTypes';

export function codeToColorCode(code: string | undefined, inspectionStandardType: InspectionStandardTypes | undefined | null | string): string {
    if (inspectionStandardType) {
        const setting = customInspectionTypeSettings[inspectionStandardType];
        if (setting !== undefined) {
            return setting.conditionScoreToColorCode(code);
        }
    }

    switch (code) {
        case 'U':
            return '#5196d5'; // blue
        case 'F':
            return '#5196d5'; // blue
        case '1':
            return '#267b45'; // green
        case '2':
            return '#2FC726'; // light green
        case '3':
            return '#FD9408'; // yellow
        case '4':
            return '#FD7808'; // orange
        case '5':
            return '#FB4B34'; // red
        case '6':
            return '#FB0006'; // dark red
        default:
            return '#5196d5'; // blue
    }
}
